import * as React from 'react'
import { connect } from 'react-redux'

import { ILocationParams } from '../../../../common//reducers/reactRouterLocation'
import {
  togglePanel,
  togglePanelOptions
} from '../../../../common/actions/layout'
import { reportFilterToggle } from '../../../../common/analytics/filtersAnalytics'
import { IRootState } from '../../../../common/reducers'
import FilterPanel from './'

interface IStateProps {
  expanded?: any
  optionsAreCollapsed?: any
}

interface IDispatchProps {
  dispatch?: any
}

interface IOwnProps {
  children: React.ReactNode
  id: string
  title: string
  expanded: boolean
  locationParams: ILocationParams
}

const mapStateToProps = (
  state: IRootState,
  ownProps: IOwnProps
): IStateProps => {
  const { layout: { toggledPanelStates, panelOptionsCollapsed } } = state

  const userSetState = toggledPanelStates[ownProps.id]
  const optionsAreCollapsed = panelOptionsCollapsed.includes(ownProps.id)

  if (userSetState === 'expanded') {
    return { expanded: true, optionsAreCollapsed }
  } else if (userSetState === 'collapsed') {
    return { expanded: false, optionsAreCollapsed }
  } else {
    return { optionsAreCollapsed }
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return { dispatch }
}

const mergeProps = (
  stateProps: IStateProps,
  dispatchProps: IDispatchProps,
  ownProps: IOwnProps
) => {
  const { dispatch, ...restDispatch } = dispatchProps

  return {
    ...ownProps,
    ...stateProps,
    ...restDispatch,
    togglePanel: (panelId: string, currentlyExpanded: boolean) => {
      const expanded = stateProps.expanded || currentlyExpanded
      reportFilterToggle(panelId, expanded)
      dispatch(togglePanel({ panelId, currentlyExpanded: expanded }))
    },
    togglePanelOptions: (panelId: string) => {
      dispatch(togglePanelOptions(panelId))
    }
  }
}

const PanelContainer = connect<IStateProps, IDispatchProps, IOwnProps>(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(FilterPanel)

export default PanelContainer
